import React from 'react';
import { DataList } from 'commons-ui';

import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { LIST_ENTITY_NAMES } from 'constant';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';
import { DEFAULT_CONFIG } from './helper';

const UserList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getUsersData } = useService();
	return (
		<DataList
			defaults={DEFAULT_CONFIG}
			fetchData={getUsersData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			entity={LIST_ENTITY_NAMES.USERS}
		/>
	);
};

export default UserList;
